import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { SidebarItemText } from './SidebarItemText';
import { BaseSidebarItemData } from './types';

type BaseSidebarItemProps = BaseSidebarItemData & {
  classNames?: {
    icon?: string;
    text?: string;
  };
};

export const BaseSidebarItem: FC<BaseSidebarItemProps> = ({ title, classNames, ...rest }) => {
  const { t } = useTranslation('ALL');

  return (
    <>
      <rest.icon
        className={twMerge('size-5 shrink-0 text-quaternary-400 motion-safe:[transition:color_300ms_ease] motion-reduce:transition-none', classNames?.icon)}
      />
      <SidebarItemText text={t(title as any)} className={classNames?.text} />
    </>
  );
};
